<script setup lang="ts">
/**
 * Skeleton primitive.
 *
 * Three variants used across the app:
 *   - `line`   one-row text placeholder
 *   - `block`  rectangular block (cards, kpi tiles)
 *   - `row`    multi-column table row (auto-sizes from `cols`)
 */
defineProps({
  variant: { type: String, default: 'line' }, // line | block | row
  rows: { type: Number, default: 1 },
  cols: { type: Number, default: 4 },
  height: { type: String, default: '' },
})
</script>

<template>
  <template v-if="variant === 'line'">
    <div v-for="i in rows" :key="i" class="sk-line" :style="height ? { height } : {}"></div>
  </template>

  <div v-else-if="variant === 'block'" class="sk-block" :style="height ? { height } : {}"></div>

  <template v-else-if="variant === 'row'">
    <div v-for="i in rows" :key="i" class="sk-row">
      <div v-for="c in cols" :key="c" class="sk-row__cell"></div>
    </div>
  </template>
</template>

<style scoped>
.sk-line,
.sk-block,
.sk-row__cell {
  background: linear-gradient(
    90deg,
    var(--color-bg-page-2) 0%,
    var(--color-bg-page) 50%,
    var(--color-bg-page-2) 100%
  );
  background-size: 200% 100%;
  animation: sk-shimmer 1.4s ease-in-out infinite;
  border-radius: var(--radius-xs);
}
.sk-line {
  height: 12px;
  margin: 8px 0;
}
.sk-line:first-child {
  width: 70%;
}
.sk-line:nth-child(2) {
  width: 90%;
}
.sk-line:nth-child(3) {
  width: 55%;
}
.sk-block {
  width: 100%;
  height: 88px;
}
.sk-row {
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--color-border-soft);
}
.sk-row__cell {
  height: 14px;
}
.sk-row__cell:first-child {
  height: 36px;
}

@keyframes sk-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
</style>
